import { AxiosInstance } from 'axios'
import {
    ListProjectPermissionsParams,
    ProjectPermission,
    ProjectPermissionCreate,
    ProjectPermissionUpdate,
    ProjectPermissionBulkUpsertRequest,
    ProjectPermissionBulkUpsertResponse,
} from './project-permission.type'
import { PaginatedResponse } from '@workspace/lib/api'

export class ProjectPermissionApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all project permissions with pagination
     */
    async list(params?: ListProjectPermissionsParams): Promise<PaginatedResponse<ProjectPermission>> {
        const response = await this.client.get<PaginatedResponse<ProjectPermission>>('/project-permissions', {
            params,
        })
        return response.data
    }

    /**
     * Get a single project permission by ID
     */
    async findOne(id: string): Promise<ProjectPermission> {
        const response = await this.client.get<ProjectPermission>(`/project-permissions/${id}`)
        return response.data
    }

    /**
     * Create a new project permission
     */
    async create(payload: ProjectPermissionCreate): Promise<ProjectPermission> {
        const response = await this.client.post<ProjectPermission>('/project-permissions', payload)
        return response.data
    }

    /**
     * Update a project permission
     */
    async update(id: string, payload: ProjectPermissionUpdate): Promise<ProjectPermission> {
        const response = await this.client.put<ProjectPermission>(`/project-permissions/${id}`, payload)
        return response.data
    }

    /**
     * Bulk upsert project permissions
     * Creates new permissions or updates existing ones based on the items provided
     */
    async bulkUpsert(payload: ProjectPermissionBulkUpsertRequest): Promise<ProjectPermissionBulkUpsertResponse> {
        const response = await this.client.put<ProjectPermissionBulkUpsertResponse>(
            '/project-permissions/bulk/upsert',
            payload,
        )
        return response.data
    }

    /**
     * Delete a project permission
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/project-permissions/${id}`)
    }

    /**
     * Delete multiple project permissions by IDs
     */
    async bulkDelete(projectId: string, ids: string[]): Promise<void> {
        await this.client.delete('/project-permissions/bulk', {
            data: { projectId, items: ids.map(id => ({ id })) },
        })
    }
}
